(ns bp-clients.tv-app.nav.views.logout-page
  "Tv client logout page.
  This page is shown when user tries to logout."
  (:require
   ["react" :refer [createRef]]
   [bp-clients.tv-app.auth.events :as auth-events]
   [bp-clients.tv-app.nav.events :as nav-events]
   [bp-libs.design-system.components.buttons :refer [Button]]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn logout-page []
  (let [main-focus-ref (createRef)]
    (fn []
      (r/create-class
       {:component-did-mount (fn [_react-component]
                               (when-let [first-button main-focus-ref.current]
                                 (.focus first-button)))
        :reagent-render (fn [_props]
                          [:main {:class "relative min-h-screen w-full dark-green-gradient overflow-hidden overscroll-contain"}
                           [:div {:class "py-[3em] h-[100vh] flex flex-col justify-center align-center text-white space-y-8"}
                            [:div {:class "flex flex-col items-center w-full"}
                             [:div {:class "font-bold text-5xl"}
                              "Deseja sair do aplicativo?"]]
                            [:div {:class "mx-auto w-[50vw] space-y-6 flex flex-col"}
                             [:div {:class "text-3xl text-center"}
                              "Confirme se deseja sair do aplicativo em sua TV. Lembre-se que será necessário fazer novamente o login para acessar o aplicativo."]]
                            [:div {:class "flex items-center justify-center space-x-4 text-lg"}
                             [Button {:color         "black"
                                      :tab-index     10
                                      :react-ref     main-focus-ref
                                      :on-click      #(do (rf/dispatch [::auth-events/logout])
                                                          (rf/dispatch [::nav-events/set-active-page :login]))
                                      :extra-classes ["px-8 py-5 outline-none text-xl"]}
                              "Confirmar"]
                             [Button {:color         "black"
                                      :tab-index     10
                                      :on-click      #(do (rf/dispatch [::nav-events/navigate-back]))
                                      :extra-classes ["px-8 py-5 outline-none text-xl"]}
                              "Cancelar"]]]])}))))
